import {
  Animated,
  Easing,
  Pressable,
  StyleSheet,
  Text,
  View,
} from "react-native";
import { Colors, Metrics, Typography } from "../../resources";
import React, { useEffect, useRef, useState } from "react";

import SIcon from "../atoms/SIcon";
import { SIconType } from "../../types";
import { ifElse } from "../../utils";

interface IProps {
  iconType: SIconType;
  count?: number;
  isOpen: boolean;
  disabled?: boolean;
  onPress: () => void;
}

const SFilterButton: React.FC<IProps> = ({
  iconType,
  count = 0,
  isOpen,
  disabled = false,
  onPress,
}) => {
  const [hover, setHover] = useState<boolean>(false);
  const [pressIn, setPressIn] = useState<boolean>(false);

  const onHoverIn = () => setHover(true);
  const onHoverOut = () => setHover(false);
  const onPressIn = () => setPressIn(true);
  const onPressOut = () => setPressIn(false);

  const title = `Tags${count === 0 ? "" : ` (${count})`}`;
  const angleRef = useRef<Animated.Value>(new Animated.Value(0));

  useEffect(() => {
    const stop = isOpen ? 1 : 0;

    Animated.timing(angleRef.current, {
      toValue: stop,
      duration: 0,
      easing: Easing.sin,
      useNativeDriver: true,
    }).start();
  }, [isOpen]);

  const spin = angleRef.current.interpolate({
    inputRange: [0, 1],
    outputRange: ["0deg", "-180deg"],
  });

  const color = ifElse(
    disabled,
    Colors.grey300,
    pressIn ? Colors.white : Colors.blue700
  );

  return (
    <Pressable
      style={[
        styles.container,
        hover && !disabled && styles.hover,
        pressIn && !disabled && styles.pressIn,
      ]}
      onPress={onPress}
      disabled={disabled}
      onMouseEnter={onHoverIn}
      onMouseLeave={onHoverOut}
      onPressIn={onPressIn}
      onPressOut={onPressOut}
    >
      <View style={styles.iconsContainer}>
        <SIcon type={iconType} size={Metrics.iconSmall} color={color} />
      </View>
      {/* <Text style={[styles.title, { color: color }]}>{title}</Text>
      <Animated.View
        style={[
          styles.chevronContainer,
          {
            transform: [
              {
                rotate: spin,
              },
            ],
          },
        ]}
      >
        <SIcon
          type={SIconType.ChevronDown}
          size={Metrics.iconSmall}
          color={color}
        />
      </Animated.View> */}
    </Pressable>
  );
};

const styles = StyleSheet.create({
  container: {
    height: Metrics.textInputHeight,
    width: Metrics.textInputHeight,
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "row",
    borderRadius: Metrics.borderRadiusStandard,
    borderColor: Colors.grey300,
    borderWidth: 1,
    backgroundColor: Colors.transparent,
    shadowColor: "#03082e",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.2,
    shadowRadius: 4,
  },
  pressIn: {
    backgroundColor: Colors.blue400,
  },
  hover: {
    backgroundColor: Colors.midnight05,
  },
  chevronContainer: {
    justifyContent: "center",
    alignItems: "center",
    marginLeft: Metrics.padding6,
    paddingRight: 3,
  },
  title: {
    ...Typography.body1,
    color: Colors.blue700,
  },
  iconsContainer: {
    marginLeft: Metrics.padding6,
    marginRight: Metrics.padding6,
  },
});

export default SFilterButton;
